import {
  PageHeaderRoot,
  HeaderTop,
  HeaderTitle,
  HeaderActions,
  TabsNav,
  Tab,
  HeaderActionButton,
  SearchBar,
  SearchSelect,
  SearchInput,
} from "./styles";

/**
 * Cabeçalho único: título + ação | abas (slot fixo) | busca (campo + valor).
 * Mesmas posições em Usuários, Projetos, etc.
 *
 * search = {
 *   columns: [{ value, label }],
 *   selectedColumn,
 *   onColumnChange,
 *   searchValue,
 *   onSearchChange,
 *   placeholder?,
 * }
 */
const PageHeader = ({
  title,
  actionLabel,
  onAction,
  actionDisabled = false,
  tabs = [],
  activeTab,
  onTabChange,
  search = null,
}) => {
  const hasTabs = Array.isArray(tabs) && tabs.length > 0;
  const hasSearch =
    search &&
    Array.isArray(search.columns) &&
    typeof search.onColumnChange === "function" &&
    typeof search.onSearchChange === "function";
  const showTabsSlot = hasTabs || hasSearch;

  return (
    <PageHeaderRoot>
      <HeaderTop>
        <HeaderTitle>{title}</HeaderTitle>
        {actionLabel && onAction ? (
          <HeaderActions>
            <HeaderActionButton
              type="button"
              onClick={onAction}
              disabled={actionDisabled}
            >
              {actionLabel}
            </HeaderActionButton>
          </HeaderActions>
        ) : null}
      </HeaderTop>

      {showTabsSlot ? (
        <TabsNav role={hasTabs ? "tablist" : undefined} aria-label={hasTabs ? title : undefined}>
          {hasTabs
            ? tabs.map((tab, index) => (
                <Tab
                  key={tab.id}
                  type="button"
                  role="tab"
                  aria-selected={activeTab === tab.id}
                  $active={activeTab === tab.id}
                  $first={index === 0}
                  onClick={() => onTabChange?.(tab.id)}
                >
                  {tab.label}
                </Tab>
              ))
            : null}
        </TabsNav>
      ) : null}

      {hasSearch ? (
        <SearchBar>
          <SearchSelect
            id={`${title}-column-select`}
            value={search.selectedColumn}
            onChange={search.onColumnChange}
            aria-label="Campo de pesquisa"
          >
            {search.columns.map((col) => (
              <option key={col.value} value={col.value}>
                {col.label}
              </option>
            ))}
          </SearchSelect>
          <SearchInput
            type="text"
            placeholder={search.placeholder || "Pesquisar..."}
            value={search.searchValue}
            onChange={search.onSearchChange}
            aria-label="Valor da pesquisa"
          />
        </SearchBar>
      ) : null}
    </PageHeaderRoot>
  );
};

export default PageHeader;
